import React, { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { Breadcrumb } from 'antd'
import Icon from 'meinian-package/src/component/icon'
import qs from 'qs'
import InspirationSelect from '../component/inspirationSelect'
import styles from './index.module.less'
import { useInspirationContext } from '../inspirationTree.context'

export default () => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const parentId = +query.parentId
  const inspirationId = +query.inspirationId
  const history = useNavigate()
  const treeData = useRef()
  const inspirationTree = useInspirationContext()
  const [currentOption, setCurrentOption] = useState([])
  const [parentOption, setParentOption] = useState([])
  const [level, setLevel] = useState(1)
  useEffect(() => {
    if (inspirationTree) {
      fetchData()
    }
  }, [inspirationTree])

  const fetchData = () => {
    treeData.current = inspirationTree
    const currentTreeNode = treeData.current.findNodeByValue(inspirationId)
    setLevel(currentTreeNode.current?.level)
    if (parentId) { // 存在父节点的时候赋值 不存在则赋值当前兄弟节点
      const parentTreeNode = treeData.current.findNodeByValue(parentId)
      setParentOption(parentTreeNode.brother)
    } else {
      setParentOption(currentTreeNode.brother)
    }
    setCurrentOption(currentTreeNode.brother)
  }

  const onLink = (id) => {
    const curItem = treeData.current.findNodeByValue(id)
    if (curItem.parent) {
      return `/home/coll/detail/${id}?inspirationId=${id}&parentId=${curItem.parent.value}&name=${curItem.current.label}`
    }
    return `/home/coll/detail/${id}?inspirationId=${id}`
  }

  return <div className={styles['mn-header-breadcrumb']}>
    <div className="mn-header-breadcrumb-back" onClick={() => { window.history.length > 1 ? history(-1) : history('/home') }}>
      <Icon type="m-Vxing_zuo" className="mn-header-breadcrumb-back-icon" />
    </div>
    <Breadcrumb>
      <Breadcrumb.Item onClick={() => { history('/home/coll/index') }}>
        <span style={{ cursor: 'pointer' }}>灵感集</span>
      </Breadcrumb.Item>
      {
        level > 2 && <Breadcrumb.Item>
          ....
        </Breadcrumb.Item>
      }
      <Breadcrumb.Item
        style={{ display: 'flex' }}
        onClick={() => {
          const url = onLink(parentId || inspirationId)
          history(url)
        }}
      >
        <InspirationSelect
          option={parentOption}
          value={parentId || inspirationId}
          onChange={(id) => {
            const url = onLink(id)
            window.open(`/meinian${url}`)
            // history(url)
          }}
        />
      </Breadcrumb.Item>
      {
        parentId ? <Breadcrumb.Item onClick={() => {
          const url = onLink(inspirationId)
          history(url)
        }}
        >
          <InspirationSelect
            option={currentOption}
            value={inspirationId}
            onChange={(id) => {
              const url = onLink(id)
              window.open(`/meinian${url}`)
              // history(url)
            }}
          />
        </Breadcrumb.Item> : null
      }
    </Breadcrumb>
  </div>
}
